import { Link } from 'react-router-dom';

const heroComics = [
  {
    slug: 'secretary-escape',
    cover: 'https://readdy.ai/api/search-image?query=Manhwa%20style%20illustration%20of%20a%20beautiful%20female%20secretary%20in%20office%20attire%20with%20intense%20expression%2C%20dark%20office%20background%2C%20dramatic%20lighting%2C%20Korean%20webtoon%20art%20style%2C%20clean%20lines%2C%20vibrant%20colors%2C%20cinematic%20composition%2C%20soft%20shadows%2C%20high%20quality%20illustration&width=600&height=800&seq=hero-comic-01&orientation=portrait',
    label: '本周推荐',
    title: '秘书的逃脱',
  },
  {
    slug: 'demon-lord',
    cover: 'https://readdy.ai/api/search-image?query=Manhwa%20style%20illustration%20of%20a%20handsome%20demon%20lord%20with%20dark%20hair%20and%20red%20eyes%2C%20gothic%20fantasy%20setting%2C%20elegant%20dark%20castle%20background%2C%20Korean%20webtoon%20art%20style%2C%20rich%20color%20palette%2C%20luxurious%20outfit%2C%20magical%20aura%2C%20clean%20composition&width=600&height=800&seq=hero-comic-02&orientation=portrait',
    label: '人气爆款',
    title: '魔王大人的契约',
  },
  {
    slug: 'warrior-rebirth',
    cover: 'https://readdy.ai/api/search-image?query=Manhwa%20style%20illustration%20of%20a%20powerful%20warrior%20with%20sword%20in%20epic%20fantasy%20battlefield%2C%20dynamic%20action%20pose%2C%20dramatic%20lighting%20effects%2C%20Korean%20webtoon%20art%20style%2C%20vibrant%20energy%20effects%2C%20heroic%20composition%2C%20clean%20lines%2C%20intense%20colors&width=600&height=800&seq=hero-comic-03&orientation=portrait',
    label: '热血必看',
    title: '重生之最强战士',
  },
];

export default function HeroSection() {
  return (
    <section className="relative bg-background-50 min-h-screen flex flex-col items-center justify-center overflow-hidden pt-16">
      <div className="relative z-10 w-full max-w-4xl mx-auto text-center px-4 md:px-6 pt-10 md:pt-16 pb-10 md:pb-16">
        <div className="inline-flex items-center gap-2 bg-primary-100/70 text-primary-600 text-xs font-medium px-4 py-2 rounded-full mb-6 md:mb-8 font-label">
          <i className="ri-sparkling-line"></i>
          <span>每日更新 · 200+ 话上新</span>
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-extrabold text-foreground-950 leading-tight font-heading">
          <span className="block">韩国漫画</span>
          <span className="block">
            <span className="text-accent-500">无删减</span>在线
          </span>
          <span className="block">
            <span className="text-accent-500">下拉式</span>阅读
          </span>
        </h1>

        <p className="mt-6 md:mt-8 text-foreground-600 text-sm md:text-base max-w-lg mx-auto leading-relaxed">
          海量无删减韩漫资源，每日极速更新，高清全彩下拉式阅读体验，完全免费，无需注册。
        </p>

        <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/romance"
            className="px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 text-sm whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            开始探索
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/#ranking"
            className="px-8 py-3.5 bg-background-100 text-foreground-700 font-medium rounded-full hover:bg-background-200 transition-all duration-300 text-sm whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            热门排行
            <i className="ri-medal-line"></i>
          </Link>
        </div>

        <div className="mt-8 flex items-center justify-center gap-6 text-foreground-500 text-xs md:text-sm">
          <span className="flex items-center gap-1">
            <i className="ri-checkbox-circle-fill text-accent-500"></i>
            20,000+ 漫画
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-checkbox-circle-fill text-accent-500"></i>
            每日更新
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-checkbox-circle-fill text-accent-500"></i>
            完全免费
          </span>
        </div>
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto px-4 md:px-6 pb-16 md:pb-24">
        <div className="flex items-end justify-center gap-3 md:gap-6">
          {heroComics.map((comic, index) => (
            <Link
              key={comic.slug}
              to={`/comic/${comic.slug}`}
              className={`group relative rounded-xl overflow-hidden cursor-pointer transition-all duration-500 hover:-translate-y-2 ${
                index === 1
                  ? 'w-[140px] md:w-[220px] z-20 -mb-2'
                  : 'w-[110px] md:w-[170px] z-10 opacity-90'
              } ${index === 0 ? 'rotate-[-3deg]' : index === 2 ? 'rotate-[3deg]' : ''}`}
            >
              <div className="aspect-[3/4]">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 韩国漫画`}
                  className="w-full h-full object-cover object-top"
                  loading={index === 1 ? 'eager' : 'lazy'}
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-2 md:p-3">
                <span className="text-background-50 text-xs font-medium px-2 py-0.5 bg-accent-500/90 rounded-md font-label">{comic.label}</span>
                <p className="text-background-50 text-xs md:text-sm font-semibold mt-1.5 truncate">{comic.title}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 animate-bounce">
        <a href="#featured" className="text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
          <i className="ri-arrow-down-s-line text-2xl"></i>
        </a>
      </div>
    </section>
  );
}